export default "__VITE_ASSET__DXuBbhrv__"